import {Expo, Quart, TweenMax} from "gsap";

export const bigSliderAnimation = (direction = "next") => {
    const activeSlideTitle = '.big-slider__slider .swiper-slide-active .big-slider__slider__slide__title';
    const activeSlideText = '.big-slider__slider .swiper-slide-active .big-slider__slider__slide__text';
    const activeSlideLink = '.big-slider__slider .swiper-slide-active .big-slider__slider__slide__link';
    const activeSlideImage = '.big-slider__slider .swiper-slide-active .big-slider__slider__slide__image';

    TweenMax.fromTo(activeSlideTitle, {opacity: 0, y: 10}, {opacity:1 , y:0, ease: Quart.easeIn})
    TweenMax.fromTo(activeSlideText, {opacity: 0, y: 10}, {opacity:1 , y:0, ease: Quart.easeIn, delay: .2})
    TweenMax.fromTo(activeSlideLink, {opacity: 0, y: 10}, {opacity:1 , y:0, ease: Quart.easeIn, delay: .3})
    TweenMax.to(activeSlideImage, 1.5, {ease: Expo.easeOut, startAt: {x: direction === 'next' ? 200 : -200}, x: 0});
}
